import React, { useCallback } from "react";
import { Form, Input, Select, Button, Space, Row, Col } from "antd";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";

const { Option } = Select;

const BusinessPartnerFilter = ({ onSearch, onReset }) => {
    const [form] = Form.useForm();

    const handleSearch = useCallback(() => {
        const values = form.getFieldsValue();
        onSearch(values);
    }, [form, onSearch]);

    const handleReset = useCallback(() => {
        form.resetFields();
        onReset();
    }, [form, onReset]);

    return (
        <div className="filter-container">
            <Form form={form} layout="inline" className="filter-form" size="default">
                <Row gutter={[16, 16]} style={{ width: "100%" }}>
                    <Col xs={24} sm={12} md={8} lg={6} xl={5}>
                        <Form.Item name="search_term" label="关键词" style={{ marginBottom: 0 }}>
                            <Input placeholder="搜索中文/英文名称、编码、联系人" allowClear onPressEnter={handleSearch} style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                        <Form.Item name="is_active" label="状态" style={{ marginBottom: 0 }}>
                            <Select placeholder="选择状态" allowClear style={{ width: "100%" }}>
                                <Option value={true}>启用</Option>
                                <Option value={false}>停用</Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                        <Form.Item style={{ marginBottom: 0 }}>
                            <Space size="small">
                                <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>
                                    搜索
                                </Button>
                                <Button icon={<ReloadOutlined />} onClick={handleReset}>
                                    重置
                                </Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default BusinessPartnerFilter;
